var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      { staticClass: "card-content" },
      [
        _c(
          "div",
          { staticClass: "columns is-mobile" },
          [
            _c(
              "div",
              { staticClass: "column is-7-desktop" },
              [
                _c("h1", { staticClass: "title is-3 has-text-primary" }, [
                  _vm._v(_vm._s(_vm.resource.nombre)),
                ]),
                _vm._v(" "),
                _c("h1", { staticClass: "subtitle is-5" }, [
                  _vm._v("Tipo: " + _vm._s(_vm.estructura.nombre)),
                  _vm.estructura.multiple
                    ? _c(
                        "span",
                        { staticClass: "has-text-primary is-size-6" },
                        [_vm._v(" (Múltiple)")]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "buttons" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button is-primary is-outlined",
                      attrs: { type: "button" },
                      on: { click: _vm.descargar },
                    },
                    [
                      _c("i", { staticClass: "fas fa-download" }),
                      _vm._v(" Descargar\n            "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button is-dark is-outlined",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.$parent.close()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fas fa-times" }),
                      _vm._v(" Cerrar\n            "),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("informacion", {
                  staticClass: "is-size-7",
                  attrs: { subunidad: _vm.resource },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "column is-4-mobile is-5-desktop" }, [
              _c("figure", { staticClass: "image" }, [
                _vm.resource.preview_uri
                  ? _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            _vm.previewModalActive = true
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: _vm.resource.preview_uri,
                            alt: "Previsualización",
                          },
                        }),
                      ]
                    )
                  : _c("img", {
                      attrs: {
                        src: "/statics/default-document.png",
                        alt: "Previsualización",
                      },
                    }),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                attrs: { active: _vm.previewModalActive },
                on: {
                  "update:active": function ($event) {
                    _vm.previewModalActive = $event
                  },
                },
              },
              [
                _c("figure", { staticClass: "image" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.resource.preview_uri,
                        target: "_blank",
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: _vm.resource.preview_uri,
                          alt: "Previsualización",
                        },
                      }),
                    ]
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("firmas", { attrs: { subunidad: _vm.resource } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }